import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {IListEditorTemplateComponent} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/IListEditorTemplateComponent';
import {ITileViewSelection, IVirtualGridTile} from '@shared/interfaces/virtual-grid-tile';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'app-platform-mail-card-viewer',
  templateUrl: './platform-mail-card-viewer.component.html',
  styleUrls: ['./platform-mail-card-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformMailCardViewerComponent implements OnInit, IListEditorTemplateComponent, IVirtualGridTile {


  action: EventEmitter<any>;
  data: any;
  inputMetadata: any;
  invalidateSubject: InvalidateSubject;
  itemSelectionChanged: EventEmitter<ITileViewSelection>;
  title: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }
  detailMail() {
    this.valueChanged.emit({item: this.data, action: {id: 'Open' }});
  }

}
